import visibilityRegion from 'lib/visibilityRegion'

import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_LAST_MINUTE } from 'constants/offer'
import { LME_URGENCY_OVERRIDES } from 'constants/lastMinute'
import config from 'constants/config'
import { pluralizeToString } from 'lib/pluralize'

export default function getUrgencyLabels(
  offer: App.Offer | App.OfferSummary,
  regionCode: string,
  showLimitedAvailability?: boolean,
) {
  const schedules = 'visibilitySchedules' in offer ?
    visibilityRegion(offer.visibilitySchedules, regionCode) :
    undefined
  if (!schedules && offer.type !== OFFER_TYPE_LAST_MINUTE) {
    return []
  }

  let nextUrgencyTags: App.OfferUrgencyLabel[]
  let messageOverride: string | undefined

  if (offer.type === OFFER_TYPE_ALWAYS_ON) {
    nextUrgencyTags = offer.urgencyTags.filter(item => item.type !== 'left')
  } else {
    nextUrgencyTags = offer.urgencyTags
  }

  if (!showLimitedAvailability) {
    nextUrgencyTags = nextUrgencyTags.filter(item => item.type !== 'limited')
  }

  if (offer.type === OFFER_TYPE_LAST_MINUTE && offer.property?.id && Object.keys(LME_URGENCY_OVERRIDES).includes(offer.property?.id)) {
    messageOverride = LME_URGENCY_OVERRIDES[offer.property?.id]
  }

  return nextUrgencyTags.map<App.OfferUrgencyLabel>((urgencyTag) => {
    return {
      start: schedules?.start,
      end: schedules?.end,
      type: urgencyTag.type,
      message: messageOverride ?? urgencyTag.message,
    }
  })
}

const ONLY_N_ROOMS_LEFT_THRESHOLD = 3

export function getOnlyNRoomLeftLabel(
  availableRooms: number,
  isShortFormat?: boolean,
  threshold?: number,
): string | undefined {
  threshold = threshold ?? config.ONLY_N_ROOMS_LEFT_THRESHOLD ?? ONLY_N_ROOMS_LEFT_THRESHOLD
  if (availableRooms > 0 && availableRooms <= threshold) {
    return isShortFormat ?
        `${pluralizeToString('room', availableRooms)} left` :
        `Only ${pluralizeToString('room', availableRooms)} left`
  }
}
